import { Button } from '@material-ui/core'
import { databaseRef } from 'config/firebase'
import * as React from 'react'
import ReactPhoneInput from 'react-phone-input-2'
import './style.scss'

interface IProps {
  parentId: string
  goToAbilities?: () => void
  isUserForwardFromHeader: boolean
  onClose: () => void
  demoLink?: string
}

export const GetNumberWindow: React.FC<IProps> = ({
  parentId,
  isUserForwardFromHeader,
  onClose,
  demoLink,
  goToAbilities
}: IProps) => {
  const [phoneNumber, setPhoneNumber] = React.useState('')
  const [errorMsg, setErrorMsg] = React.useState('')

  const handleInsertPhoneToDB = async () => {
    try {
      const userRef = await databaseRef
        .child('users')
        .child(parentId)
        .child('phone_number')
      userRef.set(phoneNumber)
    } catch (err) {
      console.error({ err })
    }
  }

  const renderPhoneNumberComponent = () => {
    return (
      <>
        <div className="label">Phone number</div>
        <ReactPhoneInput
          country={'us'}
          autoFormat={true}
          value={phoneNumber}
          onChange={phone => setPhoneNumber(phone)}
        />
        <div className="line" />
        <div className="error-msg">{errorMsg}</div>
      </>
    )
  }

  const checkPhoneNumber = () => {
    if (phoneNumber.length > 8) {
      setErrorMsg('')
      return true
    } else {
      setErrorMsg('Please enter a valid phone number')
      return false
    }
  }

  return (
    <div className="get-number-container">
      <div className="title bold">Can we get your number?</div>
      <div className="subtitle">
        We'd love to get more direct feedback about your experience
      </div>
      <div className="text">we won't share it or use it for anything else.</div>
      <div className="phone-number-container">
        {renderPhoneNumberComponent()}
      </div>
      <Button
        className="button"
        onClick={() => {
          if (checkPhoneNumber()) {
            if (isUserForwardFromHeader) {
              onClose()
            }
            handleInsertPhoneToDB()
            if (demoLink) {
              window.open(demoLink, '_blank')
            }
            if (!isUserForwardFromHeader && goToAbilities) {
              goToAbilities()
            }
          }
        }}
      >
        Done
      </Button>
    </div>
  )
}

export default GetNumberWindow



// WEBPACK FOOTER //
// ./src/components/GetNumberWindow/index.tsx